import React from 'react';
import { motion } from 'framer-motion';
import { Check, Compass, Target, BoxIcon } from 'lucide-react';
const capabilities = ['Digital strategy & UX direction', 'Web design & design systems', 'E-commerce experiences', 'WordPress, Drupal & Shopify builds', 'Custom platforms & integrations', 'Performance-focused optimisation'];
const principles = [{
  icon: Compass,
  title: 'Start with clarity',
  detail: 'We align the brief, audience and commercial objective before making a single screen.'
}, {
  icon: BoxIcon,
  title: 'Design for the whole system',
  detail: 'Every interaction is considered across content, journeys, technology and future growth.'
}, {
  icon: Target,
  title: 'Build for the outcome',
  detail: 'The work is measured by what it enables: stronger brands, better journeys and useful results.'
}];
export function AboutSection() {
  return <section id="studio" className="relative overflow-hidden bg-dark-lighter py-24" data-id="element-13" data-mp="1jncs5gdz3apj">
      <div className="mx-auto max-w-[1320px] px-4" data-id="element-14" data-mp="sqhzzrr21vfb">
        <div className="grid items-start gap-14 lg:grid-cols-[0.9fr_1.1fr] lg:gap-20" data-id="element-15" data-mp="xij9j5wu981n">
          <motion.div initial={{
          opacity: 0,
          x: -32
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          amount: 0.25
        }} transition={{
          duration: 0.55
        }} data-id="element-16" data-mp="itwp4psctq3k">
            <p className="mb-3 font-inter text-xs font-bold uppercase tracking-[0.2em] text-gold" data-id="element-17" data-mp="1gfkonjk3wojb">
              The Byteweb approach
            </p>
            <h2 className="font-syne text-4xl font-bold leading-tight text-white md:text-5xl" data-id="element-18" data-mp="16ipt99j4r499">
              Strategy, design and technology in one focused studio.
            </h2>
            <p className="mt-7 max-w-xl font-inter text-lg leading-relaxed text-white/65" data-id="element-19" data-mp="3r9gjjs4rhek7">
              We bring the practical thinking of an embedded digital team to
              every engagement. From a new e-commerce platform to a sharper
              brand experience, Byteweb turns complex goals into clear,
              considered digital products.
            </p>
            <p className="mt-5 max-w-xl font-inter leading-relaxed text-white/55" data-id="element-20" data-mp="1nytn4hr2r2tl">
              Our process is collaborative, direct and shaped around the people
              who will use—and run—what we create. The result is work that looks
              intentional, works hard and stays useful.
            </p>

            <div className="mt-9 grid gap-3 sm:grid-cols-2" data-id="element-21" data-mp="152bve0c872xc">
              {capabilities.map(capability => <div key={capability} className="flex items-start gap-3 rounded-xl border border-white/10 bg-dark p-4" data-id="element-22" data-mp="103qvy34ssn9y">
                  <Check className="mt-0.5 h-4 w-4 shrink-0 text-gold" data-id="element-23" data-mp="2zdz0qgsqulrz" />
                  <span className="font-inter text-sm leading-relaxed text-white/75" data-id="element-24" data-mp="2ui1lkdt7vlgs">
                    {capability}
                  </span>
                </div>)}
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 32
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          amount: 0.25
        }} transition={{
          duration: 0.55,
          delay: 0.1
        }} className="rounded-2xl border border-white/10 bg-dark p-6 shadow-2xl sm:p-9" data-id="element-25" data-mp="36xhu9gzm5xet">
            <div className="mb-10 flex items-center justify-between border-b border-white/10 pb-6" data-id="element-26" data-mp="2t25yd69q20wb">
              <p className="font-syne text-xl font-bold text-white" data-id="element-27" data-mp="2xx3689v9m47m">
                How we work
              </p>
              <span className="font-inter text-xs font-bold uppercase tracking-[0.18em] text-gold" data-id="element-28" data-mp="d8ylxmgvm1cs">
                01—03
              </span>
            </div>

            <div className="space-y-8" data-id="element-29" data-mp="1m6f84o67inlg">
              {principles.map((principle, index) => {
              const Icon = principle.icon;
              return <div key={principle.title} className="flex gap-5" data-id="element-30" data-mp="1v6tvru6n8es4" data-mpi={index}>
                    <div className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl border border-gold/25 bg-gold/10 text-gold" data-id="element-31" data-mp="1q7gy0ee8hnar">
                      <Icon size={20} data-id="element-32" data-mp="253py1i5y84o8" />
                    </div>
                    <div data-id="element-33" data-mp="205woqg9cmujq">
                      <div className="flex items-baseline gap-3" data-id="element-34" data-mp="204logqf444xd">
                        <span className="font-inter text-xs font-bold text-gold" data-id="element-35" data-mp="2dwthq876tdrb">
                          0{index + 1}
                        </span>
                        <h3 className="font-syne text-xl font-bold text-white" data-id="element-36" data-mp="29vzrv9a6povs">
                          {principle.title}
                        </h3>
                      </div>
                      <p className="mt-2 font-inter text-sm leading-relaxed text-white/55" data-id="element-37" data-mp="2ix7dorvikx8z">
                        {principle.detail}
                      </p>
                    </div>
                  </div>;
            })}
            </div>

            <div className="mt-10 border-t border-white/10 pt-6" data-id="element-38" data-mp="2sjs59s2xbo0r">
              <p className="font-inter text-sm leading-relaxed text-white/60" data-id="element-39" data-mp="2sjifa4hvpgv2">
                Based in Cape Town, partnering with teams wherever the work
                takes us.
              </p>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}